import eCreditFetch from './acc_interceptor.ts';
import ServiceResponse from "@/types_and_interfaces/service_response_interface.ts";
import API_CLS from "@/utils/api.ts";
import LoanBodyInterface, {UncommitedInterface} from "@/types_and_interfaces/loan_body_interface.ts";
import * as Sentry from "@sentry/react";

export const loansReqs = () => {
    
     const pre_apply = async (data: LoanBodyInterface, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.pre_apply, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            }else if(response.status === 409) {
                response.error = true
                response.message = "already_applied_err"
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "loan", action: "pre_apply" } });
            response.error = true;

            return response;
        }
    }

    const uncommited = async (data: UncommitedInterface, r_token?:string) => {

        let response:ServiceResponse = {
            error: false,
        };

        try {

            const request = await eCreditFetch(API_CLS.loans.uncommited, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });

            response.status = request?.status
            const body = await request?.json();

            if(response.status === 200) {
                response.response = body
            } else {
                response.error = true
                response.message = "error_message"
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "loan", action: "uncommited" } });
            response.error = true;

            return response;
        }
    }

    const apply_loan = async (data: LoanBodyInterface, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.loan_request_individual, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            }else if(response.status === 409) {
                response.error = true
                
                if(body.hasOwnProperty("message") && typeof body.message === "string" && body.message.includes("already exists")) {
                    response.message = "record_already_exists"
                } else response.message = "error_message"
                
                response.message = "already_applied_err"
                
            } else {
                
                if(body.hasOwnProperty("message") && typeof body.message === "string" && body.message.includes("already exists")) {
                    response.message = "record_already_exists"
                    
                } else if (body.hasOwnProperty("message") && typeof body.message === "string" && body.message.includes("in court")) {
                    response.message = "is_in_court_err"
                    
                } else response.message = "error_message"
                
                response.error = true
                
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "loan", action: "apply_loan" } });
            response.error = true;

            return response;
        }
    }

    const pending_loans = async () => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.pending_loans, {
                method: API_CLS.methods.Get,

            });
            
            response.status = request?.status

            const body = await request?.json();

            if(response.status === 200) {
                response.response = body

            } else {
                response.error = true
                response.message = "error_message"
            }

            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "loan", action: "pending_loans" } });
            response.error = true;

            return response;
        }
    }

    const fetchLoanList = async () => {
        let response:ServiceResponse = {
            error: false,
        };

        try {
            const request = await eCreditFetch(API_CLS.loans.loan_list, {
                method: API_CLS.methods.Get,
            });

            response.status = request.status

            const body = await request.json();

            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
            } else {
                response.error = true
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "loan", action: "fetch_loan_list" } });
            response.error = true;

            return response;
        }
    }

    const fetch_cr_line_loan_list = async () => {
        let response:ServiceResponse = {
            error: false,
        };

        try {
            const request = await eCreditFetch(API_CLS.loans.cr_line_loan_list, {
                method: API_CLS.methods.Get,
            });

            response.status = request.status

            const body = await request.json();

            if(typeof body === "object" && body.hasOwnProperty("message") && body.message === "ok") {
                response.response = body
            } else {
                response.error = true
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "loan", action: "fetch_cr_line_loan_list" } });
            response.error = true;

            return response;
        }
    }

    const contract = async (data:any) => {
        let response: ServiceResponse = {
            error: false,
        };
        
        try {
            const request = await eCreditFetch(API_CLS.loans.contract.get_contract, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
            });
            
            response.status = request.status
            const body = await request.blob();
            
            response.response = body;
            
            return response;
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "get_contract" } });
            response.error = true;
            return response;
        }
    };

    const transaction_contract = async (data:any) => {
        let response: ServiceResponse = {
            error: false,
        };
        
        try {
            const request = await eCreditFetch(API_CLS.loans.contract.get_transaction_contract, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
            });
            
            response.status = request.status
            const body = await request.blob();
            
            response.response = body;
            
            return response;
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "get_transaction_contract" } });
            response.error = true;
            return response;
        }
    };

    const read_contract = async (data:any) => {
        let response: ServiceResponse = {
            error: false,
        };
        
        try {
            const request = await eCreditFetch(API_CLS.loans.contract.read_contract, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
            });
            
            response.status = request.status
            const body = await request.blob();
            
            response.response = body;
            
            return response;
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "read_contract" } });
            response.error = true;
            return response;
        }
    };

    const read_transaction_contract = async (data:any) => {
        let response: ServiceResponse = {
            error: false,
        };
        
        try {
            const request = await eCreditFetch(API_CLS.loans.contract.read_transaction_contract, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
            });
            
            response.status = request.status
            const body = await request.blob();
            
            response.response = body;
            
            return response;
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "read_transaction_contract" } });
            response.error = true;
            return response;
        }
    };

    const send_contract = async (data:any) => {
        let response: ServiceResponse = {
            error: false,
        };
        
        try {
            const request = await eCreditFetch(API_CLS.loans.contract.send_contract, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
            });
            
            response.status = request.status
            const body = await request.blob();
            
            response.response = body;
            
            return response;
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "send_contract" } });
            response.error = true;
            return response;
        }
    };

    const sign1 = async (data: any) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.contract.sign_contract1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),

            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "sign_contract_step1" } });
            response.error = true;

            return response;
        }
    }

    const sign_transaction_contract1 = async (data: any) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.contract.sign_transaction_contract1, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),

            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "sign_transaction_contract_step1" } });
            response.error = true;

            return response;
        }
    }

    const sign_transaction_contract2 = async (data: any) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.contract.sign_transaction_contract2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),

            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "sign_transaction_contract_step2" } });
            response.error = true;

            return response;
        }
    }

    const sign2 = async (data: any) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.contract.sign_contract2, {
                method: API_CLS.methods.Post,
                body: JSON.stringify(data),
                
            });
            
            response.status = request?.status
            
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "contract", action: "sign_contract_step2" } });
            response.error = true;

            return response;
        }
    }

    const get_payment_schedule = async (productID:any, amount:any, months:any, r_token?:string) => {

        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.get_schedule + `/${productID}/${amount}/${months}`, {
                method: API_CLS.methods.Get,
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "payment", action: "get_payment_schedule" } });
            response.error = true;

            return response;
        }
    }

    const get_methods = async (r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.get_methods, {
                method: API_CLS.methods.Get,
                headers: r_token ? {
                    "X-ReCaptcha-Token": r_token
                } : {}
            });
            
            response.status = request?.status
            
            const body = await request?.json();

            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }

            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "payment", action: "get_methods" } });
            response.error = true;

            return response;
        }
    }

    const cr_line_transaction = async (data: any, r_token?:string) => {
        
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.loans.credit_line_transaction, {
                method: API_CLS.methods.Post,
                headers: {
                    "Content-Type":"application/json",
                    ...(r_token ? {
                        "X-ReCaptcha-Token": r_token
                    } : {})
                },
                body: JSON.stringify(data),
            });
            
            response.status = request?.status
            
            const body = await request?.json();
            
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "credit_line", action: "cr_line_transaction" } });
            response.error = true;

            return response;
        }
    }

    const oplata_pay = async (data: any) => {
        let response:ServiceResponse = {
            error: false,
        };

        const basicAuth = btoa(`${import.meta.env.VITE_OPLATA_AUTH_USER}:${import.meta.env.VITE_OPLATA_AUTH_PASSWORD}`);

        try {

            const request = await fetch(API_CLS.payments.invoice, {
                method: API_CLS.methods.Post,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Basic ${basicAuth}`
                },
                body: JSON.stringify(data),
            });

            response.status = request?.status;

            const body = await request?.text();

            if(response.status === 200) {
                response.response = body

            } else {
                response.error = true
                response.message = "error_message"
            }

            return response;

        } catch (error) {
            Sentry.captureException(error, { tags: { section: "payment", action: "oplata_pay" } });
            response.error = true;

            return response;
        }
    }


    return {
        fetchLoanList,
        apply_loan,
        pending_loans,
        contract,
        sign1,
        sign2,
        get_payment_schedule,
        read_contract,
        send_contract,
        get_methods,
        cr_line_transaction,
        fetch_cr_line_loan_list,
        transaction_contract,
        read_transaction_contract,
        sign_transaction_contract1,
        sign_transaction_contract2,
        oplata_pay,
        pre_apply,
        uncommited
    }
}